type ScreenTypes = 'mobile' | 'tablet';

export const mediaScreenFeatures: Record<ScreenTypes, string> = {
  mobile: 'max-width: 850px',
  tablet: 'max-width: 1300px',
};
